/**
 * Custom Filters - Style Collection
 * Template-specific configuration for style/trend collections
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get collection handle (slug) from URL
  let collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0] || 'all';

  // Trend name mapping for handles that don't match the API's trend name.
  // Shopify handleizes the collection title (e.g. "Farmhouse & Rustic" -> "farmhouse-rustic"),
  // dropping the spaces/ampersand the slug is built from. Map the URL handle to the real trend
  // name here; slugify then turns it back into the API slug (-> farmhouse-and-rustic).
  const TREND_NAME_MAPPING = {
    'farmhouse-rustic': 'Farmhouse & Rustic',
    'modern-contemporary': 'Modern & Contemporary',
    'classic-traditional': 'Classic & Traditional',
  };

  // Trend collections live at /api/collections/trend-{trend}
  const trendName = TREND_NAME_MAPPING[collectionHandle.toLowerCase()] || collectionHandle;
  const collectionSlug = 'trend-' + window.CustomFilters.slugify(trendName);

  window.CustomFilters.init({
    type: 'category',
    collectionHandle: collectionHandle,
    collectionSlug: collectionSlug,
    excludedFilters: ['categories', 'locations', 'trends', 'motorTypes'],
  });
});
